import { FiSearch, FiX } from "react-icons/fi";

export default function ListPageSearch({
  value,
  onChange,
  placeholder,
  hasFilters,
  onClearFilters,
  clearLabel = "Pastro filtrat",
  extras,
}) {
  const handleClearSearch = () => {
    if (!onChange) return;
    onChange({ target: { value: "" } });
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2">
      <div className="flex-1 relative">
        <FiSearch
          className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400"
          size={16}
        />
        <input
          type="text"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className="w-full h-11 pl-10 pr-10 rounded-xl border border-gray-200 bg-white text-sm placeholder-gray-400 shadow-sm transition focus:outline-none focus:ring-2 focus:ring-[var(--secondary-color)]/30 focus:border-[var(--secondary-color)]"
        />
        {value && (
          <button
            type="button"
            onClick={handleClearSearch}
            className="absolute right-3 top-1/2 -translate-y-1/2 inline-flex items-center justify-center w-6 h-6 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-700 transition"
            aria-label="Pastro kërkimin"
          >
            <FiX size={14} />
          </button>
        )}
      </div>
      {extras}
      {hasFilters && onClearFilters && (
        <button
          type="button"
          onClick={onClearFilters}
          className="h-11 inline-flex items-center justify-center gap-1.5 rounded-xl border border-gray-200 bg-white hover:bg-gray-50 px-4 text-sm font-semibold text-gray-700 shadow-sm transition"
        >
          <FiX size={14} />
          {clearLabel}
        </button>
      )}
    </div>
  );
}
